import { cn } from "@ui/utils"
import { Check } from "lucide-react"

interface CircleCheckboxProps {
  checked?: boolean
  onChange?: (checked: boolean, event?: React.MouseEvent) => void
  className?: string
  disabled?: boolean
  size?: "default" | "lg"
}

export default function CircleCheckbox({
  checked = false,
  onChange,
  className,
  disabled = false,
  size = "default",
}: CircleCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation()
        onChange?.(!checked, e)
      }}
      className={cn(
        "group",
        "relative h-5 w-5 rounded-full border-2 transition-all duration-200",
        "hover:border-muted-foreground focus:ring-muted-foreground focus:ring-1 focus:ring-offset-2 focus:outline-none",
        "border-border aria-checked:border-muted-foreground aria-checked:bg-muted-foreground",
        disabled && "cursor-not-allowed opacity-50",
        className,
        size === "lg" && "h-6 w-6"
      )}
    >
      <Check
        className={cn(
          "text-primary-foreground absolute top-1/2 left-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 transition-opacity duration-200 group-hover:opacity-100",
          checked ? "opacity-100" : "opacity-0"
        )}
      />
    </button>
  )
}
